import { render, staticRenderFns } from "./PicInfoAdd.vue?vue&type=template&id=53c6ecd7&scoped=true&"
import script from "./PicInfoAdd.vue?vue&type=script&lang=js&"
export * from "./PicInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6ecd7",
  null
  
)

export default component.exports